/**
 * Toast Notification Plugin
 *
 * Unified toast system for all OnePlaceHQ modules.
 * Wraps vue-toastification with Intercom design defaults.
 *
 * Usage in main.js:
 *   import { toastPlugin } from '@shared/plugins/toastPlugin.js'
 *   app.use(toastPlugin)
 *
 * See docs/TOAST_SYSTEM.md for full documentation.
 */
import Toast, { POSITION, TYPE } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export const toastPlugin = {
  install(app) {
    app.use(Toast, {
      position: POSITION.TOP_RIGHT,
      timeout: 4000,
      pauseOnHover: true,
      pauseOnFocusLoss: true,
      hideProgressBar: false,
      closeOnClick: true,
      closeButton: 'button',
      draggable: true,
      draggablePercent: 0.6,
      maxToasts: 4,
      newestOnTop: true,
      filterBeforeCreate: (toast, toasts) => {
        // Prevent duplicate toasts with the same content
        if (toasts.filter(t => t.content === toast.content).length > 0) {
          return false
        }
        return toast
      },
      toastDefaults: {
        [TYPE.SUCCESS]: { timeout: 4000 },
        [TYPE.INFO]: { timeout: 5000 },
        [TYPE.WARNING]: { timeout: 7000 },
        [TYPE.ERROR]: { timeout: false },
      },
    })
  },
}
